module.exports = __webpack_public_path__ + "img/icon-header-plan.7e4c245e.svg";